import { useEffect } from "react"
import { useRolloutFlag } from "../../store/rolloutFlag"

export const useFeatureFlag = (flagName: string) => {
  const { flag, loadFlag } = useRolloutFlag()

  useEffect(() => {
    loadFlag(flagName)
  }, [])

  return flag?.[flagName] ?? false
}
